import { useCallback } from 'react';

import { useQuery, UseQueryResult } from '@tanstack/react-query';

import {
  CountConfigurationResultDto,
  SearchConfigurationsWithSpecsUsingGETQueryParams,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useHandleBackErrors } from 'hooks/utils/handleBackErrors';

import { DashboardConfigurationFilter } from './types';

export const useCountConfiguration = (
  filter: Partial<DashboardConfigurationFilter>,
): UseQueryResult<CountConfigurationResultDto> => {
  const controller = useApi().AdminFonctionnelControllerApi;
  const behaviourOnError = useHandleBackErrors();

  const queryParams: SearchConfigurationsWithSpecsUsingGETQueryParams = {
    fullNameOrDescription: filter.search,
    microServiceName: filter.microServiceName,
    value: filter.value,
    hasError: filter.hasError,
  };

  const fetchCountConfiguration =
    useCallback((): Promise<CountConfigurationResultDto> => {
      return controller
        .countConfigurationsWithSpecsUsingGET(queryParams)
        .catch((error: Response) => {
          behaviourOnError(error);
          throw error;
        });
    }, [controller, queryParams, behaviourOnError]);

  return useQuery({
    queryKey: ['count-configuration', queryParams],
    queryFn: fetchCountConfiguration,
  });
};
